import { Component, OnInit } from '@angular/core';
import { MarketingFeatures, MarketingSoftwareFeature } from '../../../../models/entities/marketing-software-feature';

@Component({
    selector: 'app-marketing-features',
    templateUrl: './marketing-features.component.html',
    styleUrls: [
        './marketing-features.component.scss',
        '../../shared-marketing.component.scss',
    ],
})
export class MarketingFeaturesComponent implements OnInit
{
    features: MarketingSoftwareFeature[] = MarketingFeatures;

    constructor() {
    }

    ngOnInit() {
    }

}
